import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Fragment as _Fragment, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fd285b34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invoice-container" }
const _hoisted_2 = {
  key: 0,
  class: "main"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "发票抬头", -1))
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "tips mt4" }
const _hoisted_8 = {
  key: 0,
  class: "mt8"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("div", null, "收票信息"),
  /*#__PURE__*/_createElementVNode("div", null, "电子发票将通过短信发送")
], -1))
const _hoisted_10 = { class: "address-block" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "收票人手机", -1))
const _hoisted_12 = { class: "content mt4" }
const _hoisted_13 = { class: "info" }
const _hoisted_14 = {
  key: 1,
  class: "footer xag-page__footer"
}
const _hoisted_15 = { class: "content" }

import { reactive, computed, ComputedRef, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter, Router, useRoute } from 'vue-router'

import AppHeader from '@/components/Header.vue'
import { getUserInvoiceList } from '@/apis/invoice'
import { InvoiceItem } from '@/types/invoice'
import {
  invoiceTypeColorMap,
  invoiceTypeTextMap,
  invoiceListStorageKey,
  confirmUseInvoiceStorageKey,
  selectInoviceStorageKey,
  cacheFromStorageKey,
} from './definition'
import { clearToast, showToastFail, showToastLoading } from '@/utils/tools'
import { Button } from 'vant'
import { setStorage } from '@/compositions/useMultiPlatformStorage'

interface invoiceInfoType {
  invoiceTypeColor: string
  invoiceTypeText: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'confirm-new',
  setup(__props) {

/* eslint-disable @typescript-eslint/no-unused-vars */
const $router: Router = useRouter()
const $route = useRoute()

const store = useStore()
const userMobile = computed(() => store.state.userInfo?.mobile)
const isLoading = ref(false)

const page: {
  invoiceList: InvoiceItem[]
  currentInvoice: InvoiceItem | null
} = reactive({
  invoiceList: [] as InvoiceItem[],
  currentInvoice: null,
})
const invoiceInfo: ComputedRef<invoiceInfoType> = computed(() => {
  let currentInvoice = page.currentInvoice
  return {
    invoiceTypeColor: invoiceTypeColorMap.get(currentInvoice.invoice_type),
    invoiceTypeText: invoiceTypeTextMap.get(currentInvoice.invoice_type),
  }
})
const canUnUseInvoice = computed(() => {
  return $route?.query?.canUnUseInvoice === '1'
})

function invoiceClickHandle() {
  const invoiceList = page.invoiceList
  if (invoiceList.length) {
    // 去列表
    $router.push({
      name: 'invoice-select',
    })
  } else {
    // 去编辑页面
    $router.push({
      name: 'invoice-edit',
    })
  }
}
function confirmUse() {
  let invoiceGuid = page.currentInvoice.guid
  let invoiceType = page.currentInvoice.invoice_type
  if (!invoiceGuid) {
    showToastFail('未选择发票')
    return
  }
  setStorage(confirmUseInvoiceStorageKey, {
    invoice: { ...page.currentInvoice },
    mobile: userMobile.value,
    needInvoice: true,
  })
  $router.go(-1)
}
function cancelUse() {
  setStorage(confirmUseInvoiceStorageKey, {
    needInvoice: false,
  })
  $router.go(-1)
}
function back() {
  $router.go(-1)
}
async function initInvoice() {
  isLoading.value = true
  let storageStr = sessionStorage.getItem(invoiceListStorageKey)
  let data: InvoiceItem[]
  if (storageStr) {
    data = JSON.parse(storageStr)
  } else {
    showToastLoading()
    try {
      data = await getUserInvoiceList()
      sessionStorage.setItem(invoiceListStorageKey, JSON.stringify(data))
      clearToast()
    } catch (e) {
      showToastFail(e && e.message)
    }
  }
  let selectStorageGuid = sessionStorage.getItem(selectInoviceStorageKey)
  if (data) {
    let defaultItem
    let selectedItem
    for (let i = 0; i < data.length; i++) {
      if (data[i].default) {
        defaultItem = data[i]
      }
      if (data[i].guid === selectStorageGuid) {
        selectedItem = data[i]
      }
    }
    page.currentInvoice = selectedItem || defaultItem || data[0] || null
    page.invoiceList = data
  }
  isLoading.value = false
}
initInvoice()
sessionStorage.setItem(cacheFromStorageKey, '1')

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppHeader, { title: "发票" }),
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _hoisted_3,
            _createElementVNode("div", {
              class: "invoice-block",
              onClick: invoiceClickHandle
            }, [
              _createElementVNode("div", _hoisted_4, [
                (page.invoiceList.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, "新增发票抬头"))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("span", {
                          style: _normalizeStyle('color:' + _unref(invoiceInfo).invoiceTypeColor)
                        }, "[" + _toDisplayString(_unref(invoiceInfo).invoiceTypeText) + "]", 5),
                        _createElementVNode("span", null, _toDisplayString(page.currentInvoice.header), 1)
                      ]),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(page.currentInvoice.taxpayer_no), 1)
                    ], 64))
              ]),
              _createVNode(_component_van_icon, {
                name: "arrow",
                class: "arrow-item"
              })
            ])
          ]),
          (page.invoiceList.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(userMobile)), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_unref(Button), {
              block: "",
              class: "confirm-button",
              onClick: confirmUse
            }, {
              default: _withCtx(() => [
                _createTextVNode("确定发票申请")
              ]),
              _: 1
            }),
            (!_unref(canUnUseInvoice))
              ? (_openBlock(), _createBlock(_unref(Button), {
                  key: 0,
                  block: "",
                  onClick: cancelUse
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("不开发票")
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_unref(Button), {
                  key: 1,
                  block: "",
                  onClick: back
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("返回")
                  ]),
                  _: 1
                }))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})